"use client";
import React from "react";
import Container from "./components/containers/Container";
import { SkewLoader } from "react-spinners";

const loading = () => {
  return (
    <main className="main loading-site">
      <div className="loading-site-content">
        <div className="loading-page-spinner">
          <SkewLoader color="black" size={50} loading />
        </div>
      </div>
    </main>
  );
};

export default loading;
